import styled from "styled-components";

export const StyledCompleteJobDetails = styled.div``;

export const TitleLabelText = styled.span`
  font-weight: bold;
  font-size: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0px;
`;
